'use strict';

function hasValue (nodes) {
  for (let i = 0, length = nodes.length; i < length; i++) {
    const node = nodes[i];
    if (node.state !== 'unchecked') {
      return true;
    }
  }
  return false;
}

angular.module('web2print.recipients')
  .filter('isSelected', function () {
    return function (collection) {
      return angular.isDefined(collection) && hasValue(collection);
    };
  });
